import { AiService } from 'src/app/models/api/agentStep.model';
import { AssociatedLabelModel } from 'src/app/models/api/common';
import { FindingThreadDetailsModel, FindingThreadModel } from 'src/app/models/api/finding-thread.model';
import { DetectionRuleSeverity, FindingModel } from 'src/app/models/api/finding.model';

export class AiFindingThreadResponseModel {
  id: string;
  name: string;
  actor_names: string[];
  agent_names: string[];
  service: AiService;
  findings_by_severity: Record<DetectionRuleSeverity, number>;
  first_activity: Date;
  last_activity: Date;
  last_finding: Date;
  labels: AssociatedLabelModel[];
  owasp: string[];
}

export const toFindingThreadModel = (response: AiFindingThreadResponseModel): FindingThreadModel => {
  return {
    id: response.id,
    name: response.name,
    actorNames: response.actor_names,
    agentNames: response.agent_names,
    service: response.service,
    findingsBySeverity: response.findings_by_severity,
    firstActivity: response.first_activity,
    lastActivity: response.last_activity,
    lastFinding: response.last_finding,
    labels: response.labels ?? [],
    owasp: response.owasp ?? [],
  };
};

export interface FindingThreadDetailsResponseModel {
  id: string;
  name: string;
  actor_names: string[];
  agent_names: string[];
  service: AiService;
  findings_by_severity: Record<DetectionRuleSeverity, number>;
  first_activity: Date;
  last_activity: Date;
  integration_id: string;
  findings: FindingModel[];
  labels: AssociatedLabelModel[];
}

export const toFindingThreadDetailsModel = (response: FindingThreadDetailsResponseModel): FindingThreadDetailsModel => {
  return {
    id: response.id,
    name: response.name,
    actorNames: response.actor_names,
    agentNames: response.agent_names,
    service: response.service,
    findingsBySeverity: response.findings_by_severity,
    firstActivity: response.first_activity,
    lastActivity: response.last_activity,
    integrationId: response.integration_id,
    findings: response.findings,
    labels: response.labels ?? [],
  };
};

export interface ToolInvocationContent {
  readonly params?: string;
  readonly result?: string;
}

export interface ThreadActivitiesStepContent {
  readonly transcript?: string;
  readonly snippet?: Record<string, string>;
  readonly toolInvocation?: Record<string, ToolInvocationContent>;
}

export interface ThreadActivitiesStepResult {
  readonly stepId: string;
  readonly content: ThreadActivitiesStepContent | null;
  readonly error: string | null;
}

export interface ThreadActivitiesSummary {
  readonly totalSteps: number;
  readonly succeeded: number;
  readonly failed: number;
}

export interface ThreadActivitiesResponseModel {
  readonly summary: ThreadActivitiesSummary;
  readonly results: readonly ThreadActivitiesStepResult[];
}

export type EvidenceContentSource = 'attached_documents' | 'transcript';

export interface FindingEvidenceSensitiveContentResponseModel {
  fileDownloadUrl?: string;
  fileName?: string;
  contentSource?: EvidenceContentSource;
  sensitiveContent?: string;
}
